import {
    type ParentDocumentAcknowledgementStatusResultFromRest,
    type ParentDocumentAcknowledgementStatusResultForApollo,
} from './parent-document-acknowledgement-status';

export const parentDocumentAcknowledgementStatusTypePatcher = (
    data: ParentDocumentAcknowledgementStatusResultFromRest,
): ParentDocumentAcknowledgementStatusResultForApollo => {
    return {
        acknowledgementStatus: data.acknowledgementStatus.map(status => {
            return {
                __typename: 'ParentDocumentAcknowledgementStatus',
                childImage: status.childImage,
                childName: status.childName,
                recipient: status.recipient,

                ...(status.status === null || status.status === false
                    ? {
                          isAcknowledged: false,
                          parents: status.parents ?? [],

                          acknowledgedById: null,
                          acknowledgedByName: null,
                          acknowledgedAt: null,
                      }
                    : {
                          isAcknowledged: true,
                          acknowledgedById: status.acknowledgedById ?? '',
                          acknowledgedByName: status.acknowledgedByName ?? '',
                          acknowledgedAt: status.acknowledgedAt ?? '',

                          parents: null,
                      }),
            };
        }),
    };
};
